import {
    Component,
    Input,
    ChangeDetectionStrategy,
    ElementRef,
    OnChanges,
    SimpleChanges,
    ViewChild,
} from '@angular/core';

const titleAnimationClass = 'page-title-enter';

@Component({
    selector: 'app-page',
    templateUrl: './page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PageComponent implements OnChanges {
    @Input() public pageTitle: string = '';
    @Input() public pageSubtitle: string = '';

    @ViewChild('titleEl', { static: true })
    private titleEl: ElementRef<HTMLElement>;

    @ViewChild('subtitleEl')
    private subtitleEl: ElementRef<HTMLElement>;

    // The title and subtitle slide in when first shown (animate.enter) and
    // again whenever their text changes.
    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['pageTitle'] && !changes['pageTitle'].firstChange) {
            this.replayEnterAnimation(this.titleEl);
        }
        if (changes['pageSubtitle'] && !changes['pageSubtitle'].firstChange) {
            this.replayEnterAnimation(this.subtitleEl);
        }
    }

    private replayEnterAnimation(ref: ElementRef<HTMLElement>): void {
        const el = ref?.nativeElement;
        if (!el) return;

        el.classList.remove(titleAnimationClass);
        // Reading layout commits the removal so re-adding restarts the animation.
        el.getBoundingClientRect();
        el.classList.add(titleAnimationClass);
    }
}
